import {
  PgOnSwitchLabelDirective,
  PgOffSwitchLabelDirective,
} from './pg-switch-label.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgSwitchComponent } from './pg-switch.component';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { GestureConfig } from '../core/events/gestures-config';
import { PgSwitchFactoryComponent } from './pg-switch-factory/pg-switch-factory.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [
    PgSwitchComponent,
    PgOnSwitchLabelDirective,
    PgOffSwitchLabelDirective,
    PgSwitchFactoryComponent,
  ],
  providers: [{ provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig }],
  exports: [
    PgSwitchComponent,
    PgOnSwitchLabelDirective,
    PgOffSwitchLabelDirective,
    PgSwitchFactoryComponent,
  ],
})
export class PgSwitchModule {}
